<template>
  <div>
    <div class="inner">
      <Loading :isProcessing="isProcessing"></Loading>
      <!-- 監査が無い場合 -->
      <div v-if="!latestDiagResult.diagResultId">
        <p class="l-text t-center">ヨクスルはクライアントの労務状況を簡単にチェックし、改善にむけた課題の管理を行うことができるサービスです。</p>
        <div>
          <img src="@/assets/img/tutorial/tutorial00.svg" alt="" style="width: 100%; display: block;max-width: 1200px;margin:30px auto 30px auto;">
        </div>

        <div class="l-contentsBox l-resultBox">
          <p><img src="@/assets/img/common/icon-nav1_blue.svg" alt="" width="28"></p>
          <h3 class="l-headding is-blue">監査はまだありません</h3>
          <div class="btn-basic is-inlne is-primary mt-30" @click="goNewDiag()"><a>監査を新規作成</a></div>
        </div>
      </div>
      <!-- 監査がある場合 -->
      <div v-else>

        <!-- 監査結果がある場合 -->
        <div class="l-contentsBox l-resultBox" v-if="!latestDiagResult.hasVerifiedItem">
          <p><img src="@/assets/img/common/icon-nav1_blue.svg" alt="" width="28"></p>
          <h3 class="l-headding is-blue">監査結果はまだありません</h3>
          <p class="l-text">診断フォームで回答し、専門家ユーザーが確認した回答結果がここ反映されます。</p>
          <div v-if="isAdmin" class="btn-basic is-inlne is-primary mt-30" @click="goDiagForm()"><a>診断フォームへ</a></div>
        </div>
        <div v-else>
          <div class="caution lv1" v-if="latestDiagResult.existExpiredUpCloseDiagResult">
            <p>有効期限が近い監査があります。<a @click="goDiagList()">監査履歴</a>からご確認ください。
              <span class="icon-help"
                data-tooltip=""
                @mouseover="toggle('near_expired')" @mouseleave="toggleb('near_expired')">
                <span class="tooltip is-right" :id="'near_expired'" >1年以上更新が行われていない監査は、有効期限切れとなります。<br>有効期限切れとなった監査はすべての項目の「専門家の確認」のチェックがはずれ、達成率が０％となり、各種集計の対象から外れます。<br>再度、専門家ユーザーの確認を行ってください。</span>
                <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
              </span>
            </p>
            <p>有効期限の監査があります。<a @click="goDiagList()">監査履歴</a>からご確認ください。
              <span class="icon-help"
                data-tooltip=""
                @mouseover="toggle('expired')" @mouseleave="toggleb('expired')">
                <span class="tooltip is-right" :id="'expired'">1年以上更新が行われていない監査は、有効期限切れとなります。<br>有効期限切れとなった監査はすべての項目の「専門家の確認」のチェックがはずれ、達成率が０％となり、各種集計の対象から外れます。<br>再度、専門家ユーザーの確認を行ってください。</span>
                <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
              </span>
            </p>
          </div>

          <DiagAuditTable
            :showDownload="isAdmin || (!isAdmin && latestDiagResult.canDownloadExcel)"
            :isIpo="isIpo"
            :canDownloadExcel="latestDiagResult.canDownloadExcel"
            :isAdmin="isAdmin"
            :isProxy="isProxy"
            :score="latestDiagResult.score"
            :totalScore="latestDiagResult.totalScore"
            @emit-diag-title-change="changeDiagTitle"
          ></DiagAuditTable>

          <!-- ヨクスル -->
          <div class="completion-header" v-show="latestDiagResult.hasVerifiedItem && !isProxy">
            <div class="completion-rate">
              <p class="completion-rate__label">達成度</p>
              <p class="completion-rate__data"><strong>{{ progress }}</strong>%</p>
              <img v-if="latestDiagResult.diagResultMonthOverMonth == 'up'" src="@/assets/img/common/icon-up.svg" alt="" style="width: 15px;height: 15px;margin-left: 5px;">
              <img v-else-if="latestDiagResult.diagResultMonthOverMonth == 'down'" src="@/assets/img/common/icon-down.svg" alt="" style="width: 15px;height: 15px;margin-left: 5px;">
              <div class="progress_bar is-long"><span :style="'width: ' + progress + '%' "></span></div>
              <p class="completion-rate__data">{{ latestDiagResult.score }} / {{ latestDiagResult.totalScore }}点</p>
            </div>

            <p class="l-text-small" v-if="isIpo">IPO重要度とは 
              <span class="icon-help"
                data-tooltip=""
                @mouseover="toggle('ipo')" @mouseleave="toggleb('ipo')">
                <span id="ipo" class="tooltip is-top">IPO重要度<br>弊法人独自の基準により、問題が顕在化した場合の「財務的影響度」、「課題解決の難易度」及び「対応の緊急度」を考慮して、労務リスクの「重要度」を4つのレベル(LV)に評価・分類しています。<br>
                詳しくは<a href="https://support.roumu-kansa.jp/faq/2844419.html" target="_blank">サポートサイト</a>をご確認ください。
                </span><img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
              </span>
            </p>

          </div>

          <!-- 監査円グラフ -->
          <CompletionGraph ref="graph" :results = "latestDiagResult.diagSectionScores" v-if="!isProxy && !sectionNotUseFlag && !isIpo && !isProcessing"/>

          <!-- IPO監査円グラフ -->
          <CompletionGraphIpo ref="graphIpo" :results = "latestDiagResult.diagSectionScores" v-if="!isProxy && !sectionNotUseFlag && isIpo && !isProcessing"/>

          <div class="l-btn" v-if="isAdmin">
            <div class="btn-basic" @click="goDiagList()"><a>監査結果</a></div>
            <div class="btn-basic" v-if="this.diagResultId" @click="goDiagForm()"><a>監査フォーム</a></div>
            <div class="btn-basic" v-if="this.diagResultId" @click="goDiagManagementList()"><a>監査の管理</a></div>
            <div class="btn-basic" v-if="this.diagResultId" @click="goTaskList()"><a>課題リスト</a></div>
          </div>

          <div class="top-graphSection" v-if="!sectionNotUseFlag && isProxy">
            <div class="top-graphSection__item" style="width:0px;height:0px;"></div>
            <div class="top-graphSection__item">
              <CorporateFeatureInfoLabel
                :isProxy="isProxy"
                :corporateFeatureInfoLabels="latestDiagResult.corporateFeatureInfoLabels"
              ></CorporateFeatureInfoLabel>
            </div>
          </div>

          <!-- 優先度の高い課題 -->
          <h3 class="heading-lv3">優先度の高い課題</h3>
          <template v-if="hasRiskDiagResultItemsCount.length > 0">
            <table class="table-base audit-table table-select">
              <thead>
                <tr>
                  <th v-if="!isIpo">リスク</th>
                  <th v-if="isIpo">IPO重要度</th>
                  <th>診断名</th>
                  <th class="t-center">優先度</th>
                  <th class="t-center">対応期限</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="diagResultItem in hasRiskDiagResultItemsCount" :key="diagResultItem.diagResultItemId" @click="goTaskDetail(diagResultItem.diagResultItemId)">
                  <td v-if="!isIpo">
                    <span class="label"
                      :class="diagResultItem.riskLevelDisplayLabelClass"
                      data-tooltip=""
                      @mouseover="toggle('high_'+diagResultItem.diagResultItemId)" @mouseleave="toggleb('high_'+diagResultItem.diagResultItemId)">
                      <span class="tooltip is-right" :id="'high_'+diagResultItem.diagResultItemId" >{{diagResultItem.riskLevelDescription}}</span>
                      {{ diagResultItem.risk }}
                    </span>
                  </td>
                  <td v-if="isIpo">
                    <span class="label-level"
                      :class="diagResultItem.ipoImportanceDisplayLabelClass"
                      data-tooltip=""
                      @mouseover="toggle('high_'+diagResultItem.diagResultItemId)" @mouseleave="toggleb('high_'+diagResultItem.diagResultItemId)">
                      <span class="tooltip is-right" :id="'high_'+diagResultItem.diagResultItemId" >{{diagResultItem.ipoImportanceDescription}}</span>
                      {{ diagResultItem.ipoImportance }}
                    </span>
                  </td>
                  <td>
                    <span class="number-text">
                      <span class="number">{{ diagResultItem.sortOrder }}</span>
                      <span class="text">{{ diagResultItem.task }}</span>
                    </span>
                  </td>
                  <td class="t-center">
                    <span v-if="diagResultItem.priority">高</span>
                    <span v-else>&nbsp;</span>
                  </td>
                  <td class="t-center" :class="{'caution' : diagResultItem.isCaution}">
                    <template v-if="diagResultItem.dueDate">
                      {{ $dayjs(diagResultItem.dueDate).format("YYYY年MM月DD日") }}
                      <img v-if="diagResultItem.isCaution" src="@/assets/img/common/icon-caution.svg" alt="" width="22" height="22">
                    </template>
                    <template v-else>
                      未設定
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
          <template v-else>
            <p class="l-text">現在、対応が必要な課題はありません。</p>
          </template>
          <div class="l-btn-center" v-show="!isAdmin">
            <div class="btn-basic is-primary" @click="goDiagList()"><a>監査結果の詳細へ</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="https://code.jquery.com/jquery-3.5.1.min.js "></script>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import DiagAuditTable from '@/components/parts/diag/DiagAuditTable.vue';
import CorporateFeatureInfoLabel from '@/components/parts/corporate/CorporateFeatureInfoLabel.vue';
import CompletionGraph from '@/components/parts/human_capital/parts/CompletionGraph.vue';
import CompletionGraphIpo from '@/components/parts/human_capital/parts/CompletionGraphIpo.vue';

export default {
  components: {
    Loading,
    DiagAuditTable,
    CorporateFeatureInfoLabel,
    CompletionGraph,
    CompletionGraphIpo,
  },
  data() {
    return {
      isProcessing: false,
      latestDiagResult: {
        diagResultId: null,
        title: '',
        courseName: '',
        hasRiskDiagResultItems: [],
        existExpiredUpCloseDiagResult: false,
        hasVerifiedItem: false,
        diagSectionScores: [],
        corporateFeatureInfoLabels: [],
      },
      execChangeDiagTitle: false,
      isIpo: false,
    }
  },
  props: {
    isAdmin: {},
    isProxy: {},
    isSupple: {},
  },
  computed: {
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    diagResultId() {
      return this.$store.getters['diag/getDiagResultId'];
    },
    hasRiskDiagResultItemsCount() {
      return this.latestDiagResult.hasRiskDiagResultItems.slice(0, 5);
    },
    score() {
      return this.$store.getters['diag/getScore'];
    },
    totalScore() {
      return this.$store.getters['diag/getTotalScore'];
    },
    isOptionDiag() {
      return this.$store.getters['diag/getIsOptionDiag'];
    },
    sectionNotUseFlag() {
      return this.$store.getters['diag/getSectionNotUseFlag'];
    },
    progress() {
      return Math.floor((this.latestDiagResult.score / this.latestDiagResult.totalScore) * 100);
    },
  },
  watch: {
    async corpId() {
      await this.getLatestDiagResultForCorporate(this.corpId, null);
    },
  },
  mounted() {
    jQuery(function ($) {
      $('[data-tooltip]').each(function(id) {

        var _text = $(this).attr('data-tooltip');
        var _pos = $(this).attr('data-tooltip-pos');
        var _posclass = '';
        if(_pos == "top") {
          _posclass = 'is-top long';
        }
        if(_pos == "right") {
          _posclass = 'is-right long';
        }
        if(_pos == "bottom") {
          _posclass = 'is-bottom long';
        }
        $(this).append('<span class="tooltip ' +_posclass + '">' + _text + '</span>');
      });

      $('[data-tooltip]').on('click', function(){
        event.stopPropagation();  // 他の要素へのイベント伝播を停止
        var _h = $(this).children('.tooltip').height();
        _h += 15;
        if (!$(this).children('.tooltip').hasClass('is-right')) {
            $(this).children('.tooltip').css('top', -(_h));
        }
        if ($(this).children('.tooltip').hasClass('is-bottom')) {
            $(this).children('.tooltip').css('top', 'auto');
            $(this).children('.tooltip').css('bottom', -(_h));
        }
        $(this).children('.tooltip').fadeToggle(200);
      });
      $(document).on('click', function() {
          $('.tooltip').fadeOut(200); // 画面のどこかがクリックされたときにツールチップを隠す
      });
    })
  },
  created: function() {
  },
  methods: {
    toggle(id) {
      var tooltip = $('#'+id);
      tooltip.fadeIn(200);
    },
    toggleb(id) {
      var tooltip = $('#'+id);
      tooltip.fadeOut(200);
    },
    async getLatestDiagResultForCorporate(corpId, diagResultId = null) {
      if (corpId) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/diag/getLatestDiagResultForCorporate', {
          corpId: corpId,
          diagResultId: diagResultId,
        });
        if (res.status==200) {
          this.latestDiagResult = res.data.latestDiagResult;
          this.isIpo = res.data.latestDiagResult.isIpo;
          this.$store.dispatch('diag/setDiagResultId', this.latestDiagResult.diagResultId);
          this.$store.dispatch('diag/setTitle', this.latestDiagResult.title);
          this.$store.dispatch('diag/setDiagCourseName', this.latestDiagResult.courseName);
          this.$store.dispatch('diag/setCorpName', this.latestDiagResult.corpNm);
          this.$store.dispatch('diag/setScore', this.latestDiagResult.score);
          this.$store.dispatch('diag/setTotalScore', this.latestDiagResult.totalScore);
          this.$store.dispatch('diag/setDiagRevisionFlg', this.latestDiagResult.diagRevisionFlg);
          this.$store.dispatch('diag/setIsOptionDiag', this.latestDiagResult.isOptionDiag);
          this.$store.dispatch('diag/setSectionNotUseFlag', this.latestDiagResult.sectionNotUseFlag);
          this.$store.dispatch('diag/setCorporateFeatureInfoLabels', this.latestDiagResult.corporateFeatureInfoLabels);

        }else{
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }
    },
    goNewDiag() {
      const params = {};
      this.$router.push({ name: 'diag-course-select', params: params });
    },
    async goDiagList() {
      this.$store.dispatch('diag/setCorpId', this.corpId);
      this.$store.dispatch('diag/setDiagResultId', this.latestDiagResult.diagResultId);

      this.$router.replace({path: '/diag/'+this.corpId+'/'+this.diagResultId+'/topparam'});
//this.$router.push({ name: 'diag-top' });
    },
    // 監査結果がないときに表示される監査フォーム遷移ボタンの処理
    // 条表示・非表示の設定で表示画面が異なるため、分岐している
    goDiagForm() {
      this.$store.dispatch('diag/setDiagResultId', this.latestDiagResult.diagResultId);
      this.$store.dispatch('diag/setDiagCourseId', this.latestDiagResult.diagCourseId);
      this.$store.dispatch('diag/setSectionNotUseFlag', this.latestDiagResult.sectionNotUseFlag);

      if (!this.latestDiagResult.sectionNotUseFlag) {
        this.$router.push({ name: 'diag-section-list', query: { diagCourseId: this.latestDiagResult.diagCourseId } });
      } else {
        this.$router.push({ name: 'option-diag-answer-input', query: { diagCourseId: this.latestDiagResult.diagCourseId } });
      }
    },
    goDiagManagementList() {
      this.$store.dispatch('diag/setDiagResultId', this.latestDiagResult.diagResultId);
      this.$router.push({ name: 'diag-management-list' });
    },
    goRoughDiagAnswer(roughDiagId) {
      const params = {
        roughDiagId: roughDiagId,
      };
      this.$router.push({ name: 'rough-diag-answer', params: params, query: { roughDiagId: roughDiagId } });
    },
    changeDiagTitle(value) {
      this.execChangeDiagTitle = value;
      this.$emit("emit-diag-title-change", this.execChangeDiagTitle);
    },
    // 優先度の高い課題から課題画面に遷移する処理
    // 条表示・非表示の設定で表示画面が異なるため、分岐している
    goTaskDetail(diagResultItemId) {
      this.$store.dispatch('diag/setDiagResultItemId', diagResultItemId);
      let sectionNotUseFlag = this.$store.getters['diag/getSectionNotUseFlag'];
      if ( !sectionNotUseFlag ){
        this.$router.replace({path: '/diag/task/'+this.corpId+'/'+this.diagResultId+'/'+diagResultItemId+'/task/detailparam'});
      }else{
        this.$router.push({ name: 'task-detail' });
      }
    },
    goTaskList() {
      this.$store.dispatch('diag/setDiagResultId', this.latestDiagResult.diagResultId);
      this.$router.push({ name: 'task-list' });
    },
  }
}
</script>
